import React from 'react';
import {observer} from 'mobx-react';
import {CmsContentDecorator} from '../../services/cms/cms-content-decorator/cms-content-decorator';
import {Check} from '@sparkware/app-utils';
import {RoutedComponent} from '../base-components/routed-component/routed.component';

@observer
export class CmsPageComponent extends RoutedComponent<{}> {

  private _pageContentDecorator: CmsContentDecorator | null = null;

  private _pageContentElementRef: HTMLElement | null = null;
  private _capturePageContentElementRef = (element: HTMLDivElement | null) => {
    this._pageContentElementRef = element;
  };

  componentDidMount() {
    super.componentDidMount();
    this._decoratePageContent();
  }
  
  componentDidUpdate() {
    this._decoratePageContent();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this._disposePageContentDecorator();
  }

  private _decoratePageContent() {
    this._disposePageContentDecorator();
    if(this._pageContentElementRef) {
      let currentPage = this.services.cmsPages.currentPage;
      if (currentPage) {
        this._pageContentElementRef.innerHTML = currentPage.content;
        this._pageContentDecorator = new CmsContentDecorator(this._pageContentElementRef, this.services);
        if(currentPage.elementIdToBeScrolledIntoView) {
          this._pageContentDecorator.scrollIntoView('#' + currentPage.elementIdToBeScrolledIntoView);
        }
      }
      this._runB2CContentReadyCallback();
    }
  }

  private _disposePageContentDecorator() {
    if(this._pageContentDecorator) {
      this._pageContentDecorator.dispose();
      this._pageContentDecorator = null;
    }
  }

  private _runB2CContentReadyCallback() {
    let contentReadyFn = this.services.window.getGlobalProperty('contentReady');
    if(!contentReadyFn) {
      this.services.logger.info(`B2C didn't provide and contentReady callback`);
      return;
    }
    if(Check.isFunction(contentReadyFn)) {
      try {
        contentReadyFn();
      } catch (err) {
        this.services.logger.error(`Failed to run B2C contentReady callback for page ${this.services.cmsPages.currentPage?.url}`);
      }
    } else {
      this.services.logger.warning(`B2C window.contentReady callback is not a function`);
    }
  }

  render() {
    if(!this.services.cmsPages.currentPage) {
      return null;
    }

    return (
      <div className={'cms-route'} ref={this._capturePageContentElementRef} />
    );
  }
}
